import { render, staticRenderFns } from "./LojasCalculadoraDialog.vue?vue&type=template&id=777771e1&"
import script from "./LojasCalculadoraDialog.vue?vue&type=script&lang=ts&"
export * from "./LojasCalculadoraDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports